/** IIFE/CDN — Auth core only. Push: sibling dwtf.push.js. Analytics: dwtf.analytics.js. Rank: dwtf.rank.js. Support: dwtf.support.js. QR: dwtf.qr.js. i18n: i18n/*.json (ADR 0009). */
export { DwtfAuth } from "./core/auth.js";
export type { DwtfConfig } from "./core/auth.js";
export { mountAuthWidget } from "./ui/widget.js";
export type { MountAuthOptions } from "./ui/widget.js";
export { openBackupModal, openRestoreModal } from "./ui/modals.js";
export { encodeRecovery, parseRecovery } from "./ui/recovery.js";
